// https://uis-prime-vision.prod.expedia.com/docs
// corresponds to affiliateHubLink schema

enum AnalyticsLinkType {
  CUSTOM = 'custom',
  PREDEFINED = 'predefined',
}

export { AnalyticsLinkType };
